import React, { useState } from 'react';
import { Space, Card, Input, Flex, Select, Button, Row, Col, Image, Drawer, Badge, Modal, Tag, Table, Checkbox } from 'antd';
import { EditOutlined, FilterOutlined } from '@ant-design/icons';
import TagsPicker from "components/pickers/product_tag"
import CategoryPicker from "components/pickers/product_category"
import ProductInventoryModal from '../ProductInventoryModal';
import { useWorkSpace } from 'contexts/workspace';

const { Search } = Input;

const getSelectedCount = (value) => {
  if (Array.isArray(value)) {
    return value.length;
  }

  if (value === null || value === undefined || value === '') {
    return 0;
  }

  if (typeof value === 'object') {
    return Object.keys(value).length > 0 ? 1 : 0;
  }

  return 1;
};

const ProductListMobile = ({ viewModel }) => {
  const [showFilterSheet, setShowFilterSheet] = useState(false);
  const [showActionSheet, setShowActionSheet] = useState(false);
  const [limitModalOpen, setLimitModalOpen] = useState(false);
  const { workspace } = useWorkSpace();
  const productLimitStatus = workspace?.subscriptionStatus?.canCreateProduct;

  const handleCreateProduct = () => {
    if (productLimitStatus?.canCreate === false) {
      setLimitModalOpen(true);
      return;
    }
    viewModel.navigate('/product/add');
  };

  const {
    data,
    filter,
    selectedProductIds,
    expandedInventoryRows,
    bulkTagModalOpen,
    bulkRemoveTagModalOpen,
    bulkActionLoading,
    bulkTagIds,
    bulkRemoveTagIds,
    bulkTagSaving,
    bulkRemoveTagSaving,
    inventoryModalOpen,
    inventoryProduct,
    inventoryRows,
    inventorySaving,
    inventoryImporting,
    inventoryImportPreviewOpen,
    inventoryImportPreviewRows,
    inventoryImportUnmatchedIds,
    inventoryImportSaving,
    setFilterValue,
    navigate,
    openBulkTagModal,
    saveBulkTags,
    saveBulkRemoveTags,
    onBulkActionSelect,
    getProductTags,
    getProductCategories,
    getProductOptionSummary,
    getSortedVariantsByStock,
    getVariantDisplayName,
    openInventoryModal,
    onVariantStockChange,
    saveInventory,
    importInventoryFromFile,
    applyImportedInventory,
    setExpandedInventoryRows,
    setInventoryModalOpen,
    setBulkTagIds,
    setBulkTagModalOpen,
    setBulkRemoveTagIds,
    setBulkRemoveTagModalOpen,
    setInventoryImportPreviewOpen,
    setSelectedProductIds,
  } = viewModel;

  const tagCount = getSelectedCount(filter?.tag);
  const categoryCount = getSelectedCount(filter?.category);
  const hasSelection = selectedProductIds.length > 0;
  const activeFilterCount = [
    filter?.stock && filter.stock !== 'all' ? 1 : 0,
    filter?.status && filter.status !== 'all' ? 1 : 0,
    tagCount > 0 ? 1 : 0,
    categoryCount > 0 ? 1 : 0,
  ].reduce((sum, current) => sum + current, 0);

  const onClearFilters = () => {
    setFilterValue('stock', 'all');
    setFilterValue('status', 'all');
    setFilterValue('tag', null);
    setFilterValue('category', null);
    setShowFilterSheet(false);
  };

  const onSelectBulkAction = (key) => {
    setShowActionSheet(false);
    onBulkActionSelect({ key });
  };

  return (
    <Space direction="vertical" size={16} style={{ width: "100%", paddingBottom: hasSelection ? 84 : 0 }}>
      {/* Search and Filter Card */}
      <Card style={{ width: "100%" }}>
        <Space direction="vertical" size={8} style={{ width: "100%" }}>
          {/* Search */}
          <Flex gap={8} align='center'>
            <Search
              placeholder="Tên hoặc mã"
              onChange={e => setFilterValue("info", e.target.value)}
              style={{ flex: 1 }}
              value={filter.info}
            />
            <Badge count={activeFilterCount} size='small' offset={[-4, 4]}>
              <Button icon={<FilterOutlined />} onClick={() => setShowFilterSheet(true)} />
            </Badge>
          </Flex>

          {/* Add Button */}
            <Flex justify='flex-end' style={{ width: '100%' }}>
              <Button
                type='primary'
                onClick={handleCreateProduct}
                title={productLimitStatus?.canCreate === false ? `Đã đạt giới hạn ${productLimitStatus?.limit} sản phẩm` : ''}
              >
                Thêm mới
              </Button>
            </Flex>
        </Space>
      </Card>

      <Drawer
        title="Bộ lọc"
        placement="bottom"
        height="auto"
        open={showFilterSheet}
        onClose={() => setShowFilterSheet(false)}
      >
        <Space direction="vertical" size={12} style={{ width: "100%" }}>
          <Row gutter={8}>
            <Col span={12}>
              <div>
                <label>Kho</label>
                <Select
                  defaultValue={"all"}
                  value={filter.stock}
                  style={{ width: "100%" }}
                  onChange={e => setFilterValue("stock", e)}
                >
                  <Select.Option value="all">Tất cả</Select.Option>
                  <Select.Option value="in_stock">Còn</Select.Option>
                  <Select.Option value="low_stock">Còn ít</Select.Option>
                  <Select.Option value="out_of_stock">Hết</Select.Option>
                </Select>
              </div>
            </Col>
            <Col span={12}>
              <div>
                <label>Trạng thái</label>
                <Select
                  defaultValue={"all"}
                  value={filter.status}
                  style={{ width: "100%" }}
                  onChange={e => setFilterValue("status", e)}
                >
                  <Select.Option value="all">Tất cả</Select.Option>
                  <Select.Option value="show">Đang hiển thị</Select.Option>
                  <Select.Option value="hide">Đang ẩn</Select.Option>
                </Select>
              </div>
            </Col>
            <Col span={12}>
              <div>
                <label>Tag</label>
                <TagsPicker
                  value={filter.tag}
                  style={{ width: "100%" }}
                  onChange={e => setFilterValue("tag", e)}
                />
              </div>
            </Col>
            <Col span={12}>
              <div>
                <label>Danh mục</label>
                <CategoryPicker
                  value={filter.category}
                  style={{ width: "100%" }}
                  onChange={e => setFilterValue("category", e)}
                />
              </div>
            </Col>
          </Row>
          <Flex justify='space-between'>
            <Button onClick={onClearFilters}>Clear</Button>
            <Button type='primary' onClick={() => setShowFilterSheet(false)}>Xong</Button>
          </Flex>
        </Space>
      </Drawer>

      {/* Product List as Cards */}
      <Space direction="vertical" size={8} style={{ width: "100%" }}>
        {(data || []).map(record => {
          const productTags = getProductTags(record);
          const productCategories = getProductCategories(record);
          const optionSummary = getProductOptionSummary(record);
          const variants = getSortedVariantsByStock(record);
          const isExpanded = !!expandedInventoryRows[record.id];
          const visibleVariants = isExpanded ? variants : variants.slice(0, 3);
          const selected = selectedProductIds.includes(record.id);

          return (
            <Card 
              key={record.id}
              style={{ cursor: 'pointer' }}
              onClick={() => navigate(`/product/edit/${record.id}`)}
            >
              <Row gutter={8}>
                <Col span={8}>
                  <Image 
                    width="100%" 
                    src={record.thumbnail?.url} 
                    preview={false}
                    style={{ borderRadius: 4 }}
                  />
                </Col>
                <Col span={16}>
                  <Space direction='vertical' size={4} style={{ width: "100%" }}>
                    <Flex align='center' gap={8} onClick={(e) => e.stopPropagation()}>
                      <Checkbox
                        checked={selected}
                        onChange={(e) => {
                          const checked = e?.target?.checked;
                          if (checked) {
                            const next = Array.from(new Set([...(selectedProductIds || []), record.id]));
                            setSelectedProductIds(next);
                          } else {
                            setSelectedProductIds((selectedProductIds || []).filter(id => id !== record.id));
                          }
                        }}
                      />
                      <div style={{ fontWeight: 500, fontSize: 14, lineHeight: 1.4 }}>
                        {record.name}
                      </div>
                    </Flex>

                    {/* Tags */}
                    {productTags.length > 0 && (
                      <div style={{ fontSize: 12 }}>
                        <strong>Tag:</strong> {productTags.join(', ')}
                      </div>
                    )}

                    {/* Categories */}
                    {productCategories.length > 0 && (
                      <div style={{ fontSize: 12 }}>
                        <strong>Danh mục:</strong> {productCategories.join(', ')}
                      </div>
                    )}

                    <div style={{ fontSize: 12 }}>
                      <strong>Biến thể:</strong>
                      <Space direction='vertical' size={0} style={{ display: 'flex', marginTop: 2 }}>
                        {optionSummary.map((line, index) => (
                          <div key={`${record?.id || 'product'}-opt-mobile-${index}`}>{line}</div>
                        ))}
                      </Space>
                    </div>

                    {record.track_inventory && (
                    <div style={{ fontSize: 12 }}>
                      <strong>Tồn kho:</strong>
                      <Space direction='vertical' size={0} style={{ display: 'flex', marginTop: 2 }}>
                        {visibleVariants.map(variant => {
                          const variantName = getVariantDisplayName(variant);
                          const onHand = Number(variant?.on_hand_quantity ?? 0) || 0;
                          const stockText = onHand === 0 ? 'Hết hàng' : onHand;
                          return <div key={variant.id}>{variantName}: {stockText}</div>
                        })}
                        {variants.length > 3 && (
                          <Button
                            type='link'
                            style={{ padding: 0, height: 'auto', textAlign: 'left', justifyContent: 'flex-start' }}
                            onClick={(e) => {
                              e.stopPropagation();
                              setExpandedInventoryRows(prev => ({ ...prev, [record.id]: !isExpanded }));
                            }}
                          >
                            {isExpanded ? 'Thu gọn' : 'Xem thêm'}
                          </Button>
                        )}
                      </Space>
                    </div>
                    )}

                    {/* Edit Button */}
                    <Flex justify='flex-end' style={{ marginTop: 8 }}>
                      {record.track_inventory && (
                      <Button
                        style={{ marginRight: 8 }}
                        onClick={(e) => {
                          e.stopPropagation();
                          openInventoryModal(record);
                        }}
                      >
                        Cập nhật tồn
                      </Button>
                      )}
                      <Button 
                        type='primary'
                        onClick={(e) => {
                          e.stopPropagation();
                          navigate(`/product/edit/${record.id}`);
                        }}
                      >
                        <EditOutlined /> Sửa
                      </Button>
                    </Flex>
                  </Space>
                </Col>
              </Row>
            </Card>
          );
        })}
      </Space>

      {/* Empty State */}
      {(!data || data.length === 0) && (
        <Card style={{ textAlign: 'center', padding: '40px 20px' }}>
          <p style={{ color: '#999' }}>Không có sản phẩm nào</p>
        </Card>
      )}

      {hasSelection && (
        <div
          style={{
            position: 'fixed',
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 1000,
            background: '#fff',
            borderTop: '1px solid #f0f0f0',
            boxShadow: '0 -4px 12px rgba(0, 0, 0, 0.06)',
            padding: '10px 12px calc(10px + env(safe-area-inset-bottom, 0px))',
          }}
        >
          <Flex justify='space-between' align='center' gap={8}>
            <div style={{ fontWeight: 500 }}>Đã chọn: {selectedProductIds.length}</div>
            <Button type='primary' loading={bulkActionLoading} onClick={() => setShowActionSheet(true)}>
              Chức năng
            </Button>
          </Flex>
        </div>
      )}

      <Drawer
        title='Chức năng'
        placement='bottom'
        height='auto'
        open={showActionSheet}
        onClose={() => setShowActionSheet(false)}
      >
        <Space direction='vertical' size={8} style={{ width: '100%' }}>
          <Button
            block
            onClick={() => {
              setShowActionSheet(false);
              openBulkTagModal();
            }}
          >
            Gắn tag
          </Button>
          <Button block onClick={() => onSelectBulkAction('remove_tag')}>Gỡ tag</Button>
          <Button block onClick={() => onSelectBulkAction('export_inventory')}>Xuất file kho hàng</Button>
          <Button block onClick={() => onSelectBulkAction('hide')}>Ẩn trên website</Button>
          <Button block onClick={() => onSelectBulkAction('show')}>Hiện trên website</Button>
          <Button block onClick={() => setShowActionSheet(false)}>Đóng</Button>
        </Space>
      </Drawer>

      <ProductInventoryModal
        open={inventoryModalOpen}
        product={inventoryProduct}
        rows={inventoryRows}
        saving={inventorySaving}
        importLoading={inventoryImporting}
        onCancel={() => setInventoryModalOpen(false)}
        onSave={saveInventory}
        onImportFromFile={importInventoryFromFile}
        onVariantStockChange={onVariantStockChange}
        getVariantDisplayName={getVariantDisplayName}
      />

      <Modal
        title={`Dữ liệu import tồn kho - ${inventoryProduct?.name || ''}`}
        open={inventoryImportPreviewOpen}
        onCancel={() => setInventoryImportPreviewOpen(false)}
        onOk={applyImportedInventory}
        okText='Cập nhật tồn kho'
        cancelText='Đóng'
        confirmLoading={inventoryImportSaving}
        width={1000}
      >
        <Space direction='vertical' style={{ width: '100%' }}>
          <div>
            File có {inventoryImportPreviewRows.length} dòng dữ liệu.
            {inventoryImportUnmatchedIds.length > 0 ? ` Có ${inventoryImportUnmatchedIds.length} dòng có variant_id không tồn tại trong hệ thống.` : ''}
          </div>
          <Table
            pagination={false}
            rowKey='key'
            dataSource={inventoryImportPreviewRows}
            rowClassName={row => row.matched ? '' : 'inventory-import-row-unmatched'}
            columns={[
              {
                title: 'Dòng',
                render: (_, row) => Number(row.row_index ?? 0)
              },
              {
                title: 'variant_id',
                dataIndex: 'variant_id'
              },
              {
                title: 'Biến thể',
                dataIndex: 'variant_title'
              },
              {
                title: 'Trạng thái',
                render: (_, row) => row.matched
                  ? <Tag color='success'>Khớp</Tag>
                  : <Tag color='error'>Không khớp</Tag>
              },
              {
                title: 'Tồn hiện tại',
                render: (_, row) => row.matched ? Number(row.current_on_hand_quantity ?? 0) : '-'
              },
              {
                title: 'Tồn từ file',
                render: (_, row) => Number(row.next_on_hand_quantity ?? 0)
              },
              {
                title: 'Đã đặt',
                render: (_, row) => row.matched ? Number(row.reserved_quantity ?? 0) : '-'
              },
              {
                title: 'Khả dụng mới',
                render: (_, row) => row.matched ? Number(row.next_available_quantity ?? 0) : '-'
              }
            ]}
          />
        </Space>
      </Modal>

      <Modal
        title='Gắn tag hàng loạt'
        open={bulkTagModalOpen}
        onCancel={() => setBulkTagModalOpen(false)}
        onOk={saveBulkTags}
        okText='Lưu'
        cancelText='Đóng'
        confirmLoading={bulkTagSaving}
      >
        <Space direction='vertical' style={{ width: '100%' }}>
          <div>Chọn tag để gắn cho {selectedProductIds.length} sản phẩm đã chọn</div>
          <TagsPicker
            mode='multiple'
            value={bulkTagIds}
            onChange={setBulkTagIds}
            style={{ width: '100%' }}
            placeholder='Chọn tag'
          />
        </Space>
      </Modal>

      <Modal
        title='Gỡ tag hàng loạt'
        open={bulkRemoveTagModalOpen}
        onCancel={() => setBulkRemoveTagModalOpen(false)}
        onOk={saveBulkRemoveTags}
        okText='Lưu'
        cancelText='Đóng'
        confirmLoading={bulkRemoveTagSaving}
      >
        <Space direction='vertical' style={{ width: '100%' }}>
          <div>Chọn tag để gỡ khỏi {selectedProductIds.length} sản phẩm đã chọn</div>
          <TagsPicker
            mode='multiple'
            value={bulkRemoveTagIds}
            onChange={setBulkRemoveTagIds}
            style={{ width: '100%' }}
            placeholder='Chọn tag'
          />
        </Space>
      </Modal>

      <Modal
        title='Giới hạn sản phẩm'
        open={limitModalOpen}
        onCancel={() => setLimitModalOpen(false)}
        footer={[
          <Button key='cancel' onClick={() => setLimitModalOpen(false)}>
            Đóng
          </Button>,
          <Button
            key='upgrade'
            type='primary'
            onClick={() => {
              setLimitModalOpen(false);
              navigate('/account/subscription');
            }}
          >
            Nâng cấp gói
          </Button>,
        ]}
      >
        <p>
          Bạn đã đạt giới hạn <strong>{productLimitStatus?.limit}</strong> sản phẩm.
        </p>
        <p>
          Để có thể thêm sản phẩm, vui lòng nâng cấp gói cước của bạn.
        </p>
      </Modal>
    </Space>
  );
};

export default ProductListMobile;

